
<template>
  <div>
    <div class="dashboard-container">
      <!-- Sidebar -->
      <nav class="sidebar" :class="{ 'open': sidebarOpen }">
        <!-- Mobile Menu Toggle Tab (sticks out from sidebar) -->
        <button class="mobile-menu-tab" @click="toggleSidebar">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M3 12h18M3 6h18M3 18h18"/>
          </svg>
        </button>

        <div class="sidebar-header">
          <div class="logo">
            <h1>Offerta</h1>
          </div>
        </div>
        <ul class="nav-menu">
          <li class="nav-item">
            <div class="nav-link"
                 :class="{ 'active': active === 'account' }"
                 data-page="account"
                 @click="setActive('account')">
              <svg class="nav-icon"
                   viewBox="0 0 24 24">
                <path
                      d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z" />
              </svg>
              Account
            </div>
          </li>
          <li class="nav-item">
            <div class="nav-link"
                 :class="{ 'active': active === 'create-offer' }"
                 data-page="create-offer"
                 @click="setActive('create-offer')">
              <svg class="nav-icon"
                   viewBox="0 0 24 24">
                <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 2 2h8c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
              </svg>
              Create Offer
            </div>
          </li>
          <li class="nav-item">
            <div class="nav-link"
                 :class="{ 'active': active === 'how-to' }"
                 data-page="how-to"
                 @click="setActive('how-to')">
              <svg class="nav-icon"
                   viewBox="0 0 24 24">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z" />
              </svg>
              How to Use
            </div>
          </li>
          <li class="nav-item">
            <div class="nav-link logout-link"
                 @click="handleLogout">
              <svg class="nav-icon"
                   viewBox="0 0 24 24">
                <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" />
              </svg>
              Logout
            </div>
          </li>
        </ul>
      </nav>

      <!-- Main Content -->
      <main class="main-content">
        <!-- Account Page -->
        <div :class="active === 'account' ? 'active' : ''"
             class="page"
             id="account">
          <div class="page-header">
            <h1 class="page-title">Account</h1>
            <p class="page-subtitle">Manage your realtor agent profile and licensing information.</p>
          </div>

          <div class="chart-container">
            <h3 class="chart-title">Agent Profile Details</h3>
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 0rem;">
              <div>
                <p style="margin-bottom: 0.8rem;"><strong>Agent Name:</strong> {{ userInfo.agent_name }}</p>
                <p style="margin-bottom: 0.8rem;"><strong>Agent License ID:</strong> {{ userInfo.agent_license }}</p>
              </div>
              <div>
                <p style="margin-bottom: 0.8rem;"><strong>Broker Company:</strong> {{ userInfo.broker_company }}</p>
                <p style="margin-bottom: 0.8rem;"><strong>Broker Company License ID:</strong> {{ userInfo.broker_company_license }}</p>
              </div>
              <div>
                <p style="margin-bottom: 0.8rem;"><strong>Phone:</strong> {{ userInfo.phone }}</p>
              </div>
              <div>
                <p style="margin-bottom: 0.8rem;"><strong>Email:</strong> {{ userInfo.email }}</p>
              </div>
            </div>
              <div>
                <p style="margin-bottom: 0.8rem;"><strong>Address:</strong> {{ userInfo.address }}</p>
              </div>
              <div>
                <p style="margin-bottom: 0.8rem;"><strong>Supported Area:</strong> {{ userInfo.supported_area }}</p>
              </div>
          </div>

          <div class="chart-container" v-if="false">
            <h3 class="chart-title">DocuSign API Configuration</h3>
            <div style="padding: 1rem 0;">
              <label style="display: block; margin-bottom: 0.5rem; font-weight: 600; color: #333;">DocuSign API Key:</label>
              <div style="display: flex; gap: 1rem; align-items: center;">
                <input type="password"
                       id="docusign-api-key"
                       placeholder="Enter your DocuSign API key"
                       style="flex: 1; padding: 0.8rem; border: 2px solid rgba(100, 145, 222, 0.2); border-radius: 8px; font-size: 0.9rem; transition: border-color 0.3s ease; background: rgba(255, 255, 255, 0.9);" />
                <button id="update-api-key"
                        style="padding: 0.8rem 1.5rem; background: linear-gradient(135deg, #6491DE, #073D7F); color: white; border: none; border-radius: 8px; font-weight: 600; cursor: pointer; transition: all 0.3s ease; box-shadow: 0 4px 15px rgba(100, 145, 222, 0.3);">Update</button>
              </div>
              <p style="margin-top: 0.5rem; color: #666; font-size: 0.85rem;">This API key will be used for document signing integration</p>
            </div>
          </div>

        </div>

        <!-- Create Offer Page -->
        <div :class="active === 'create-offer' ? 'active' : ''"
             class="page"
             id="create-offer">
          <div class="page-header">
            <h1 class="page-title">Create Offer</h1>
            <p class="page-subtitle">Generate professional real estate offer documents.</p>
          </div>

          <div class="chart-container"
               style="margin-bottom: 2rem;">
            <h3 class="chart-title">Create New Offer</h3>
            <div style="padding: 1rem 0;">
              <div class="form-group">
                <label class="form-label">{{ inputLabel }}</label>
                <textarea class="form-input form-textarea"
                          id="seller-agent-info"
                          ref="offerInputTextArea"
                          v-model="offerInputText"
                          @input="saveOfferInputText"
                          :placeholder="inputPlaceholder"
                          :style="{ height: textareaHeight, minHeight: '300px' }"></textarea>
                <div v-if="sellerAgentInformationErrMsg" class="error-message">{{ sellerAgentInformationErrMsg }}</div>
                <div v-if="errMsg" class="error-message">{{ errMsg }}</div>
              </div>

              <div class="form-group">
                <label class="form-label" for="doc-type-select">Document Type:</label>
                <select class="form-input"
                        id="doc-type-select"
                        v-model="docType">
                  <option value="RPA_BRBC">RPA + BRBC (default)</option>
                  <option value="RPA_ONLY">RPA only</option>
                  <option value="BRBC_ONLY">BRBC only</option>
                  <option value="ADDENDUM">Addendum (ADM)</option>
                </select>
              </div>
            </div>
          </div>

          <!-- Create Offer Button -->
          <div style="text-align: center; margin-bottom: 2rem;">
            <button class="btn-primary"
                    id="create-pdf-btn">Create Offer PDF</button>
          </div>

          <!-- PDF Review Section (Hidden initially) -->
          <div class="pdf-review"
               id="pdf-review-section">
            <div class="chart-container">
              <h3 class="chart-title">Review Offer Document</h3>
              <div style="padding: 1rem 0;">
                <div class="pdf-preview"
                     id="pdf-preview">
                  <!-- 📄 Offer Document Preview
                  <br><br>
                  <span style="font-size: 0.9rem; color: #888;">Document generated successfully</span> -->
                  <iframe class="frame"
                          :src="pdfPerUrl"
                          frameborder="0"></iframe>
                </div>
                <!-- DocuSign Email Inputs -->
                <div class="docusign-emails" style="margin-bottom: 1.5rem;">
                  <h4 style="margin-bottom: 1rem; color: #333; font-size: 1rem;">DocuSign Recipients</h4>
                  <div style="display: grid; grid-template-columns: 1fr; gap: 1rem;">
                    <div class="form-group">
                      <label class="form-label">Buyer 1 Email (Required):</label>
                      <input type="email"
                             class="form-input"
                             id="buyer1-email"
                             placeholder="Enter buyer 1 email address"
                             v-model="buyer1Email">
                      <div v-if="buyer1EmailError" class="error-message">{{ buyer1EmailError }}</div>
                    </div>
                    <div class="form-group">
                      <label class="form-label">Buyer 2 Email (Optional):</label>
                      <input type="email"
                             class="form-input"
                             id="buyer2-email"
                             placeholder="Enter buyer 2 email address"
                             v-model="buyer2Email">
                      <div v-if="buyer2EmailError" class="error-message">{{ buyer2EmailError }}</div>
                    </div>
                    <div class="form-group" v-if="requiresBuyerAgent">
                      <label class="form-label">Buyer Agent Email (Required):</label>
                      <input type="email"
                             class="form-input"
                             id="buyer-agent-email"
                             placeholder="Enter buyer agent email address"
                             v-model="buyerAgentEmail">
                      <div v-if="buyerAgentEmailError" class="error-message">{{ buyerAgentEmailError }}</div>
                    </div>
                  </div>
                </div>

                <div class="button-group">
                  <button class="btn-secondary"
                          id="download-pdf-btn">Download PDF</button>
                  <button class="btn-primary"
                          id="submit-docusign-btn">Submit to DocuSign</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- How to Use Page -->
        <div :class="active === 'how-to' ? 'active' : ''"
             class="page"
             id="how-to">
          <div class="page-header">
            <h1 class="page-title">How to Use Offerta</h1>
            <p class="page-subtitle">Quick start guide with copy-paste examples.</p>
          </div>

          <div class="chart-container" style="margin-bottom: 2rem;">
            <h3 class="chart-title">Quick Start Guide</h3>
            <div style="padding: 1rem 0; line-height: 1.8;">
              <p style="margin-bottom: 1rem; color: #555;">
                Follow these simple steps to create a professional real estate offer document:
              </p>
              <ol style="margin-left: 1.5rem; color: #333;">
                <li style="margin-bottom: 0.8rem;"><strong>Navigate to "Create Offer"</strong> - Click the "Create Offer" menu item in the sidebar</li>
                <li style="margin-bottom: 0.8rem;"><strong>Enter Information</strong> - Copy and paste seller agent information and offer details into the text area</li>
                <li style="margin-bottom: 0.8rem;"><strong>Generate PDF</strong> - Click "Create Offer PDF" button to generate the document</li>
                <li style="margin-bottom: 0.8rem;"><strong>Review Document</strong> - Review the generated PDF in the preview section</li>
                <li style="margin-bottom: 0.8rem;"><strong>Submit or Download</strong> - Either download the PDF or submit directly to DocuSign for signatures</li>
              </ol>
            </div>
          </div>

          <!-- Fields & Examples by Document Type (tabbed) -->
          <div class="chart-container" style="margin-bottom: 2rem;">
            <h3 class="chart-title">Fields &amp; Examples by Document Type</h3>
            <p style="margin: 0.25rem 0 1rem; color: #555; font-size: 0.95rem; line-height: 1.6;">
              Pick the document type you'll create, copy its starter example into the
              "Seller Agent Information And Offer Details" field, then adjust using the field list below.
              <br><em style="color: #888;">Your buyer-agent details are filled automatically from your account — you don't type them here.</em>
            </p>

            <!-- Tabs -->
            <div style="display: flex; gap: 0.5rem; flex-wrap: wrap; border-bottom: 2px solid #e2e8f0; margin-bottom: 1.25rem;">
              <button v-for="(guide, key) in docGuides"
                      :key="key"
                      @click="howToTab = key"
                      :style="{
                        padding: '0.6rem 1.1rem', border: 'none', cursor: 'pointer', fontSize: '0.9rem',
                        fontWeight: howToTab === key ? '700' : '500',
                        color: howToTab === key ? '#073D7F' : '#666',
                        background: howToTab === key ? 'rgba(100,145,222,0.12)' : 'transparent',
                        borderBottom: howToTab === key ? '3px solid #6491DE' : '3px solid transparent',
                        borderRadius: '8px 8px 0 0'
                      }">
                {{ guide.label }}
              </button>
            </div>

            <!-- Active guide -->
            <div v-if="docGuides[howToTab]">
              <p style="color: #555; font-size: 0.95rem; margin-bottom: 1rem;">{{ docGuides[howToTab].blurb }}</p>

              <!-- Starter example -->
              <h4 style="color: #6491DE; margin: 0 0 0.6rem; font-size: 1rem;">Starter example — copy &amp; paste</h4>
              <div style="position: relative; margin-bottom: 1.75rem;">
                <button
                  @click="copyToClipboard(docGuides[howToTab].starter)"
                  style="position: absolute; top: 10px; right: 10px; padding: 6px 12px; background: #6491DE; color: white; border: none; border-radius: 4px; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
                  @mouseenter="$event.target.style.background = '#073D7F'"
                  @mouseleave="$event.target.style.background = '#6491DE'">
                  Copy
                </button>
                <pre style="background: #f8f9fa; border: 1px solid #e2e8f0; border-radius: 8px; padding: 1.5rem; padding-top: 3rem; overflow-x: auto; font-size: 0.88rem; color: #333; font-family: 'Courier New', monospace; white-space: pre-wrap;">{{ docGuides[howToTab].starter }}</pre>
              </div>

              <!-- Field reference -->
              <h4 style="color: #6491DE; margin: 0 0 0.6rem; font-size: 1rem;">Fields you can control</h4>
              <div v-for="group in docGuides[howToTab].groups" :key="group.title" style="margin-bottom: 1.5rem;">
                <h5 style="color: #333; font-size: 0.92rem; margin: 0 0 0.5rem;">{{ group.title }}</h5>
                <table class="table" style="border: 1px solid #e2e8f0; border-radius: 8px; overflow: hidden;">
                  <thead>
                    <tr>
                      <th style="width: 42%;">Field</th>
                      <th>How to phrase it</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="f in group.fields" :key="f.name">
                      <td>
                        <span style="font-weight: 600; color: #333;">{{ f.name }}</span>
                        <span v-if="f.tag"
                              style="margin-left: 0.4rem; background: #22c55e; color: #fff; font-size: 0.68rem; font-weight: 700; padding: 1px 6px; border-radius: 10px; vertical-align: middle;">{{ f.tag }}</span>
                        <div v-if="f.note" style="color: #888; font-size: 0.78rem; font-style: italic; margin-top: 2px;">{{ f.note }}</div>
                      </td>
                      <td><code style="background: #f1f5f9; padding: 2px 6px; border-radius: 4px; font-size: 0.82rem; color: #0f172a;">{{ f.example }}</code></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="chart-container">
            <h3 class="chart-title">Tips & Best Practices</h3>
            <div style="padding: 1rem 0;">
              <ul style="margin-left: 1.5rem; color: #333; line-height: 1.8;">
                <li style="margin-bottom: 0.8rem;"><strong>Quick Number Formatting:</strong> Use shorthand formats like "3m" or "1.5m" for faster input instead of typing out full numbers</li>
                <li style="margin-bottom: 0.8rem;"><strong>Buyer Email Required:</strong> Make sure to include buyer email addresses as they will be needed for DocuSign signature requests</li>
                <li style="margin-bottom: 0.8rem;"><strong>Loan Contingencies:</strong> Clearly specify the loan contingency period (in days) and the desired closing timeline</li>
                <li style="margin-bottom: 0.8rem;"><strong>Flexible Item Descriptions:</strong> When listing electronics or special items, you don't need exact names. For example, simply type "Nest" instead of "Nest Smart Thermostat Model XYZ"</li>
                <li style="margin-bottom: 0.8rem;"><strong>Always Review First:</strong> Carefully review the generated PDF document before submitting to DocuSign to ensure all information is accurate and complete</li>
              </ul>
            </div>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>

<script setup>
import { ref, nextTick, watch, computed } from 'vue'
import { useRouter } from 'vue-router';
import { supabase } from '../supabase';
const router = useRouter();
const offerId = ref(null)

/* 
Exp Realty Of Northern California Inc. 
Navneet Bal  #02225860      
915 Highland Pointe Dr., Ste 250 CA 95678                                                                             
nav.test@gmail.com 408-656-8602
assessor's parcel no: 12725035


We Shi. test1@gmail.com
Bo Qing. test2@yahoo.com
869 Richardson Ct, PALO ALTO, CA 94303
Price $ 4 0
Deposit 3%
Cash at Close 3 000 000-3%
15 days loan contingency
45 Days Closing
Standard Home warranty Requested.
Electronics requested: Stove ONLY
AVID write accordingly .
Single Family House with large backyard
House has a few trees in the backyard .
Hardwood floor in living room
Hardwood floor in bedroom 1 2
Bathroom 1 is in original condition, needs remodeling
House has little usage value, main value is in the land
Disclosure You should have it.
Send directly for signature.
After done, send out directly offer
*/

const baseUrl = process.env.VUE_APP_API_BASE_URL || ''
const pdfPerUrl = ref("")
const errMsg = ref("")
const sellerAgentInformationErrMsg = ref("")

// DocuSign email fields
const buyer1Email = ref("")
const buyer2Email = ref("")
const buyerAgentEmail = ref("")

// Email validation error messages
const buyer1EmailError = ref("")
const buyer2EmailError = ref("")
const buyerAgentEmailError = ref("")

// Email validation function
const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}

// Clear email errors
const clearEmailErrors = () => {
  buyer1EmailError.value = ""
  buyer2EmailError.value = ""
  buyerAgentEmailError.value = ""
}

// Validate DocuSign emails
const validateDocuSignEmails = () => {
  clearEmailErrors()
  let isValid = true

  // Validate buyer1 email (required)
  if (!buyer1Email.value.trim()) {
    buyer1EmailError.value = "Buyer 1 email is required"
    isValid = false
  } else if (!validateEmail(buyer1Email.value.trim())) {
    buyer1EmailError.value = "Please enter a valid email address"
    isValid = false
  }

  // Validate buyer2 email (optional, but if provided must be valid)
  if (buyer2Email.value.trim() && !validateEmail(buyer2Email.value.trim())) {
    buyer2EmailError.value = "Please enter a valid email address"
    isValid = false
  }

  // Validate buyer agent email — only required for doc types the agent signs.
  if (requiresBuyerAgent.value) {
    if (!buyerAgentEmail.value.trim()) {
      buyerAgentEmailError.value = "Buyer agent email is required"
      isValid = false
    } else if (!validateEmail(buyerAgentEmail.value.trim())) {
      buyerAgentEmailError.value = "Please enter a valid email address"
      isValid = false
    }
  }

  return isValid
}

const userInfo = ref({})

// ---- How to Use: per-doc-type field guide & starter examples ----
const howToTab = ref('RPA_BRBC')
const NEW = 'NEW'

// Starter examples (copy-paste into the "Seller Agent Information And Offer
// Details" box). The buyer agent is taken from your account, not typed here.
const exampleRpaBrbc = `ABC Realty Company Inc.
John Smith #01234567
123 Main Street, Suite 100 CA 94000
john.smith@example.com 555-123-4567
assessor's parcel no: 12345678

Jane Doe. jane.doe@email.com
Mike Johnson. mike.j@email.com
123 Oak Avenue, SUNNYVALE, CA 94085
Price $2,500,000
Deposit 3%
Cash at Close 2,500,000-3%
15 days loan contingency
4 days investigation contingency
21 days insurance contingency
45 Days Closing
Offer expires 07/03/2025 at 9PM
Seller pays buyer's broker 2.5%
Smoke alarms, CO detectors, water heater bracing paid by seller
Point-of-sale inspections/reports paid by seller
Point-of-sale corrective/remedial actions paid by buyer
HOA transfer fees paid by both
Seller credit to buyer 0%
BRBC: exclusive representation for 1138 Laureles Dr, Los Altos, CA 94022; 456 Oak Avenue, Palo Alto, CA 94301
BRBC end date 09/30/2025
Standard Home warranty Requested.
Electronics requested: Stove ONLY
AVID write accordingly.
Single Family House with large backyard
Hardwood floor in living room
Bathroom 1 is in original condition, needs remodeling`

const exampleRpaOnly = `ABC Realty Company Inc.
John Smith #01234567
123 Main Street, Suite 100 CA 94000
john.smith@example.com 555-123-4567
assessor's parcel no: 12345678

Jane Doe. jane.doe@email.com
Mike Johnson. mike.j@email.com
123 Oak Avenue, SUNNYVALE, CA 94085
Price $2,500,000
Deposit 3%
Cash at Close 2,500,000-3%
15 days loan contingency
4 days investigation contingency
21 days insurance contingency
45 Days Closing
Offer expires 07/03/2025 at 9PM
Seller pays buyer's broker 2.5%
Smoke alarms, CO detectors, water heater bracing paid by seller
Point-of-sale inspections/reports paid by seller
Point-of-sale corrective/remedial actions paid by buyer
HOA transfer fees paid by both
Seller credit to buyer 0%
Standard Home warranty Requested.
Electronics requested: Stove ONLY
AVID write accordingly.
Single Family House with large backyard
Hardwood floor in living room
Bathroom 1 is in original condition, needs remodeling`

const exampleBrbcOnly = `Jane Doe. jane.doe@email.com
Mike Johnson. mike.j@email.com
Buyer's broker compensation 2.5%
Exclusive representation for 1138 Laureles Dr, Los Altos, CA 94022
BRBC end date 09/30/2025`

const exampleAddendum = `Jane Doe. jane.doe@email.com
Mike Johnson. mike.j@email.com
Sellers: Robert Brown and Susan Brown
123 Oak Avenue, SUNNYVALE, CA 94085
Addendum terms:
1. Seller to credit buyer $5,000 toward closing costs.
2. Refrigerator, washer and dryer to remain with the property.
3. Seller to complete termite repairs prior to close of escrow.`

// Reusable field groups (a group = a labelled block of controllable fields).
const grpSellerAgent = {
  title: 'Seller agent (first block)',
  fields: [
    { name: 'Firm, agent name & license', example: 'ABC Realty Inc.   John Smith #01234567' },
    { name: 'Contact & address', example: '123 Main St, Suite 100 CA 94000   john@example.com 555-123-4567' },
    { name: 'Assessor parcel no. (APN)', example: "assessor's parcel no: 12345678" },
  ],
}
const grpProperty = {
  title: 'Property',
  fields: [
    { name: 'Address (street, city, ZIP)', example: '123 Oak Avenue, Sunnyvale, CA 94085', note: 'County is auto-derived from the city' },
  ],
}
const grpPrice = {
  title: 'Price & financing',
  fields: [
    { name: 'Offer price', example: 'Price $2,500,000   (or "2.5m")' },
    { name: 'All-cash offer', example: 'All cash' },
    { name: 'Deposit', example: 'Deposit 3%   (or $75,000)' },
    { name: 'Cash at close / down payment', example: 'Cash at Close 2,500,000-3%' },
    { name: 'Loan amount / %', example: 'Loan $1,500,000   (or 60%)' },
    { name: 'Close of escrow', example: '45 days closing' },
    { name: 'Loan qualification', example: 'Fully underwritten preapproval   (or preapproval / prequalification)' },
    { name: 'Loan type', example: 'FHA   (or VA / seller financing)' },
  ],
}
const grpContingencies = {
  title: 'Contingencies',
  fields: [
    { name: 'Loan contingency', example: '15 days loan contingency' },
    { name: 'Appraisal contingency', example: '17 days appraisal contingency' },
    { name: 'Investigation contingency', example: '4 days investigation contingency' },
    { name: 'Insurance contingency', example: '21 days insurance contingency', tag: NEW },
  ],
}
const grpOffer = {
  title: 'Offer terms',
  fields: [
    { name: 'Offer expiration (date &/or time)', example: 'Offer expires 07/03/2025 at 9PM' },
    { name: 'Seller credit to buyer', example: 'Seller credit 1%', note: '0% / none leaves it blank' },
    { name: 'Rent back', example: 'Seller rent back 14 days' },
  ],
}
const grpCostAlloc = {
  title: 'Cost allocation — say buyer, seller, or both',
  fields: [
    { name: "Seller payment to buyer's broker", example: "Seller pays buyer's broker 2.5%   (or $10,000)", note: 'Default 2.5%' },
    { name: 'Q4 · 10B(1) Smoke alarms / CO detectors / water heater bracing', example: 'Smoke alarms, CO detectors, water heater bracing paid by seller', tag: NEW, note: 'Default blank' },
    { name: 'Q5 · Gov. Point of Sale inspections / reports', example: 'Point-of-sale inspections paid by seller', tag: NEW, note: 'Default blank' },
    { name: 'Q6 · Gov. Point of Sale corrective / remedial', example: 'Point-of-sale corrective actions paid by buyer', tag: NEW, note: 'Default blank' },
    { name: 'HOA transfer fees', example: 'HOA transfer fees paid by both', tag: NEW, note: 'Default blank' },
  ],
}
const grpItems = {
  title: 'Included items & condition (AVID)',
  fields: [
    { name: 'Included electronics / items', example: 'Electronics requested: Stove only' },
    { name: 'Room-by-room condition', example: 'Hardwood floor in living room; bathroom 1 needs remodeling' },
    { name: 'Other special terms', example: 'Seller to rent back up to 14 days at no cost' },
  ],
}
const grpBuyers = {
  title: 'Buyers',
  fields: [
    { name: 'Buyer 1 — name & email', example: 'Jane Doe. jane.doe@email.com', note: 'Required' },
    { name: 'Buyer 2 — name & email', example: 'Mike Johnson. mike.j@email.com', note: 'Optional' },
  ],
}
// BRBC representation fields, without compensation (RPA docs list compensation
// under Cost allocation, since it is the same input feeding both forms).
const grpBrbcCore = {
  title: 'BRBC — buyer representation',
  fields: [
    { name: 'Representation period end (duration)', example: 'BRBC end date 09/30/2025   (or "ends in 3 months")', note: 'Default: 3 months out' },
    { name: 'Exclusivity', example: 'Exclusive representation   (or non-exclusive)', tag: NEW },
    { name: 'Specified property(ies)', example: 'Exclusive for 1138 Laureles Dr, Los Altos, CA 94022', tag: NEW, note: 'Box is checked only when an address is given' },
  ],
}
// BRBC-only doc has no RPA cost section, so compensation lives here.
const grpBrbcFull = {
  title: 'BRBC — buyer representation',
  fields: [
    { name: 'Representation period end (duration)', example: 'BRBC end date 09/30/2025   (or "ends in 3 months")', note: 'Default: 3 months out' },
    { name: "Buyer's-broker compensation", example: "Buyer's broker compensation 2.5%   (or $10,000)", note: 'Default 2.5%' },
    { name: 'Exclusivity', example: 'Exclusive representation   (or non-exclusive)', tag: NEW },
    { name: 'Specified property(ies)', example: 'Exclusive for 1138 Laureles Dr, Los Altos, CA 94022', tag: NEW, note: 'Box is checked only when an address is given' },
  ],
}

// Addendum needs only buyers, the property, and the free-text terms body.
// Addendum sellers: party names only — no email, and sellers do not sign
// (only the buyers sign; the buyer agent does not sign the addendum).
const grpAddendumSellers = {
  title: 'Sellers (names only)',
  fields: [
    { name: 'Seller 1 & 2 — name', example: 'Sellers: Robert Brown and Susan Brown', note: 'Optional; no email — sellers do not sign here' },
  ],
}
// Addendum header: the "ADDENDUM No." field and the two agreement checkboxes at
// the top of the form. By default the addendum attaches to the Purchase
// Agreement (neither box checked); wording in the input flips the checkboxes.
const grpAddendumHeader = {
  title: 'Addendum header (number & what it attaches to)',
  fields: [
    { name: 'Addendum number', example: 'Addendum No. 2   (or "Addendum A")', note: 'Optional — number or letter; defaults to 1' },
    { name: 'Attach to the Purchase Agreement', example: '(default — just don\'t mention any other agreement)', note: 'Leaves both header checkboxes blank' },
    { name: 'Attach to a Residential Lease', example: 'This addendum amends the residential lease / month-to-month rental agreement', note: 'Checks the "Residential Lease" box' },
    { name: 'Attach to another agreement ("Other")', example: 'This addendum is attached to the Vacant Land Purchase Agreement', note: 'Checks the "Other" box and prints that name on the line' },
  ],
}
const grpAddendumTerms = {
  title: 'Addendum terms',
  fields: [
    { name: 'Terms & conditions to add', example: '1. Seller to credit buyer $5,000 toward closing costs.\n2. Refrigerator, washer and dryer to remain.', note: 'Free text; number each item on its own line' },
  ],
}

const docGuides = {
  RPA_BRBC: {
    label: 'RPA + BRBC',
    blurb: 'Creates the full purchase offer (RPA) plus the Buyer Representation & Broker Compensation agreement (BRBC).',
    starter: exampleRpaBrbc,
    groups: [grpSellerAgent, grpProperty, grpPrice, grpContingencies, grpOffer, grpCostAlloc, grpItems, grpBrbcCore, grpBuyers],
  },
  RPA_ONLY: {
    label: 'RPA only',
    blurb: 'Creates the Residential Purchase Agreement and its related disclosures — no BRBC.',
    starter: exampleRpaOnly,
    groups: [grpSellerAgent, grpProperty, grpPrice, grpContingencies, grpOffer, grpCostAlloc, grpItems, grpBuyers],
  },
  BRBC_ONLY: {
    label: 'BRBC only',
    blurb: 'Creates only the Buyer Representation & Broker Compensation agreement between the buyer and your brokerage — property/price are not required.',
    starter: exampleBrbcOnly,
    groups: [grpBuyers, grpBrbcFull],
  },
  ADDENDUM: {
    label: 'Addendum (ADM)',
    blurb: 'Creates a standalone C.A.R. Addendum (ADM) that appends custom terms and conditions to the purchase agreement (or a residential lease / other agreement). Only the buyers sign; seller names are printed for reference (no email, no signature).',
    starter: exampleAddendum,
    groups: [grpBuyers, grpAddendumSellers, grpProperty, grpAddendumHeader, grpAddendumTerms],
  },
}

// Copy to clipboard function
const copyToClipboard = async (text) => {
  try {
    await navigator.clipboard.writeText(text)
    alert('Copied to clipboard!')
  } catch (err) {
    console.error('Failed to copy:', err)
    alert('Failed to copy to clipboard')
  }
}

// Load user info from sessionStorage initially
if (sessionStorage.getItem('userInfo')) {
  const user = JSON.parse(sessionStorage.getItem('userInfo'))
  user.address = `${user.address}, ${user.city}, CA ${user.zip}`
  userInfo.value = user
}

// Fetch fresh agent info from backend on component mount
async function fetchAgentInfo() {
  try {
    const response = await fetch(baseUrl + '/user', {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${sessionStorage.getItem('token')}`
      }
    })

    if (response.status === 401) {
      sessionStorage.removeItem('token')
      router.push('/login')
      return
    }

    if (response.ok) {
      const result = await response.json()
      if (result.success && result.data) {
        // Update userInfo with fresh data from backend
        const agentData = result.data
        userInfo.value = {
          ...userInfo.value,
          agent_name: agentData.buyer_agent || userInfo.value.agent_name,
          agent_license: agentData.buyer_agent_license || userInfo.value.agent_license,
          broker_company: agentData.buyer_agent_firm || userInfo.value.broker_company,
          broker_company_license: agentData.buyer_agent_firm_license || userInfo.value.broker_company_license,
          phone: agentData.buyer_agent_phone || userInfo.value.phone,
          email: agentData.buyer_agent_email || userInfo.value.email,
          address: `${agentData.buyer_agent_street_address || ''}, ${agentData.buyer_agent_city || ''}, CA ${agentData.buyer_agent_zip || ''}`,
          supported_area: agentData.buyer_agent_support_location || userInfo.value.supported_area
        }
      }
    }
  } catch (error) {
    console.error('Error fetching agent info:', error)
    // Keep using cached userInfo if fetch fails
  }
}

// Call fetchAgentInfo when component mounts
fetchAgentInfo()
// if (sessionStorage.getItem('user') === 'BayAreaCindyYang') {
//   userInfo.value = userInfo1.value
// } else if (sessionStorage.getItem('user') === 'ongoing') {
//   userInfo.value = userInfo2.value
// } else {
//   userInfo.value = userInfo1.value
// }

async function previewPdf() {
  try {
    const response = await getPdfStream()
    const blob = new Blob([response.data], { type: 'application/pdf' })
    const url = window.URL.createObjectURL(blob)
    window.open(url)
  } catch (error) {
    console.error('预览PDF失败', error)
  }
}

const active = ref('account')
if (sessionStorage.getItem('activePage')) {
  active.value = sessionStorage.getItem('activePage')
} else {
  sessionStorage.setItem('activePage', 'account')
}

const sidebarOpen = ref(false)

// Textarea height management
const textareaHeight = ref('500px')
const offerInputTextArea = ref(null)
const offerInputText = ref('')

// Document type selection: 'RPA_BRBC' (default), 'RPA_ONLY', 'BRBC_ONLY', 'ADDENDUM'
const docType = ref('RPA_BRBC')

// Which parties actually sign each doc type (mirrors the backend
// DocTypeSpec.signers). The addendum is signed by the buyers only — the buyer
// agent does not sign it, so we don't collect/require the agent email for it.
const DOC_TYPE_SIGNERS = {
  RPA_BRBC: ['buyer1', 'buyer2', 'buyer_agent'],
  RPA_ONLY: ['buyer1', 'buyer2', 'buyer_agent'],
  BRBC_ONLY: ['buyer1', 'buyer2', 'buyer_agent'],
  ADDENDUM: ['buyer1', 'buyer2'],
}
const signerRolesForDocType = computed(() => DOC_TYPE_SIGNERS[docType.value] || ['buyer1', 'buyer2', 'buyer_agent'])
const requiresBuyerAgent = computed(() => signerRolesForDocType.value.includes('buyer_agent'))

// The create-offer input label + placeholder change per doc type: the RPA/BRBC
// family is driven by seller-agent + offer details, whereas the addendum is
// buyers / sellers / property / terms. Add an entry here when a new doc type's
// input differs from the default.
const INPUT_COPY = {
  ADDENDUM: {
    label: 'Addendum Details:',
    placeholder: 'Enter the buyer(s) name & email, seller name(s), property address, the addendum number (optional), what it attaches to (default: purchase agreement), and the terms to add (one per line).',
  },
}
const DEFAULT_INPUT_COPY = {
  label: 'Seller Agent Information And Offer Details:',
  placeholder: 'Enter seller agent information (name, license ID, brokerage firm, contact details, etc.) and offer details',
}
const inputLabel = computed(() => (INPUT_COPY[docType.value] || DEFAULT_INPUT_COPY).label)
const inputPlaceholder = computed(() => (INPUT_COPY[docType.value] || DEFAULT_INPUT_COPY).placeholder)

// ---- Per-doc-type input caching ----
// Each doc_type keeps its own draft. The RPA family (RPA_BRBC / RPA_ONLY /
// BRBC_ONLY) shares the same kind of input, so the legacy single cache is
// migrated into all three; ADDENDUM (and future doc types) start separate.
const LEGACY_CONTENT_KEY = 'offerInputTextContent'
const RPA_FAMILY = ['RPA_BRBC', 'RPA_ONLY', 'BRBC_ONLY']
const contentKey = (dt) => `offerInputTextContent:${dt}`
let saveTimeout = null   // debounce handle for auto-save (used by the watcher too)

// One-time migration of the old shared draft into the RPA-family caches.
const legacyContent = localStorage.getItem(LEGACY_CONTENT_KEY)
if (legacyContent && !localStorage.getItem('offerInputCacheMigrated')) {
  for (const dt of RPA_FAMILY) {
    if (localStorage.getItem(contentKey(dt)) === null) {
      localStorage.setItem(contentKey(dt), legacyContent)
    }
  }
  localStorage.setItem('offerInputCacheMigrated', '1')
}

function loadOfferInputForDocType(dt) {
  const saved = localStorage.getItem(contentKey(dt))
  offerInputText.value = saved !== null ? saved : ''
}

// Load saved textarea height from localStorage
const savedHeight = localStorage.getItem('offerInputTextAreaHeight')
if (savedHeight) {
  textareaHeight.value = savedHeight
}

// Load the draft for the initially-selected doc type.
loadOfferInputForDocType(docType.value)

// When the doc type changes, persist the draft we're leaving and load the one
// we're switching to.
watch(docType, (newDt, oldDt) => {
  if (saveTimeout) {
    clearTimeout(saveTimeout)
    saveTimeout = null
  }
  localStorage.setItem(contentKey(oldDt), offerInputText.value)
  loadOfferInputForDocType(newDt)
})

function setActive(page) {
  sessionStorage.setItem('activePage', page)
  active.value = page
  sidebarOpen.value = false // Close sidebar on mobile after selecting
}

function toggleSidebar() {
  sidebarOpen.value = !sidebarOpen.value
}

async function handleLogout() {
  // Sign out from Supabase
  await supabase.auth.signOut()

  // Clear session storage
  sessionStorage.removeItem('token')
  sessionStorage.removeItem('userInfo')

  // Redirect to login page
  router.push('/')
}

// Save textarea height when user resizes it
function saveTextareaHeight() {
  if (offerInputTextArea.value) {
    const height = offerInputTextArea.value.style.height || offerInputTextArea.value.offsetHeight + 'px'
    textareaHeight.value = height
    localStorage.setItem('offerInputTextAreaHeight', height)
  }
}

// Save textarea content (debounced auto-save) under the current doc type's key.
function saveOfferInputText() {
  if (saveTimeout) {
    clearTimeout(saveTimeout)
  }
  saveTimeout = setTimeout(() => {
    localStorage.setItem(contentKey(docType.value), offerInputText.value)
  }, 1000) // Save 1 second after user stops typing
}
// Add smooth scrolling and additional interactions
document.querySelectorAll('.card').forEach((card) => {
  card.addEventListener('mouseenter', function () {
    this.style.transform = 'translateY(-8px) scale(1.02)'
  })

  card.addEventListener('mouseleave', function () {
    this.style.transform = 'translateY(0) scale(1)'
  })
})

// Simulate real-time data updates
function updateMetrics() {
  const values = document.querySelectorAll('.card-value')
  values.forEach((value) => {
    value.style.transform = 'scale(1.1)'
    setTimeout(() => {
      value.style.transform = 'scale(1)'
    }, 200)
  })
}

nextTick().then(() => {
  const apiKeyInput = document.getElementById('docusign-api-key')
  const updateButton = document.getElementById('update-api-key')
  const createPdfBtn = document.getElementById('create-pdf-btn')
  const pdfReviewSection = document.getElementById('pdf-review-section')
  const downloadPdfBtn = document.getElementById('download-pdf-btn')
  const submitDocusignBtn = document.getElementById('submit-docusign-btn')

  // Setup ResizeObserver to save textarea height when user resizes it
  if (offerInputTextArea.value) {
    const resizeObserver = new ResizeObserver(() => {
      saveTextareaHeight()
    })
    resizeObserver.observe(offerInputTextArea.value)
  }

  // API Key functionality
  if (apiKeyInput && updateButton) {
    apiKeyInput.addEventListener('focus', function () {
      this.style.borderColor = '#6491DE'
      this.style.boxShadow = '0 0 0 3px rgba(102, 126, 234, 0.1)'
    })

    apiKeyInput.addEventListener('blur', function () {
      this.style.borderColor = 'rgba(100, 145, 222, 0.2)'
      this.style.boxShadow = 'none'
    })

    updateButton.addEventListener('click', function () {
      const apiKey = apiKeyInput.value
      if (apiKey.trim()) {
        this.style.transform = 'scale(0.95)'
        this.innerHTML = 'Updating...'

        setTimeout(() => {
          this.style.transform = 'scale(1)'
          this.innerHTML = 'Updated!'
          this.style.background = 'linear-gradient(135deg, #43e97b, #38f9d7)'

          setTimeout(() => {
            this.innerHTML = 'Update'
            this.style.background = 'linear-gradient(135deg, #6491DE, #073D7F)'
          }, 2000)
        }, 1000)
      } else {
        alert('Please enter a valid API key')
      }
    })

    updateButton.addEventListener('mouseenter', function () {
      this.style.transform = 'translateY(-2px)'
      this.style.boxShadow = '0 6px 20px rgba(102, 126, 234, 0.4)'
    })

    updateButton.addEventListener('mouseleave', function () {
      this.style.transform = 'translateY(0)'
      this.style.boxShadow = '0 4px 15px rgba(100, 145, 222, 0.3)'
    })
  }

  // Create PDF functionality
  if (createPdfBtn) {
    createPdfBtn.addEventListener('click', async function () {
      // Clear all error messages when user clicks create button
      sellerAgentInformationErrMsg.value = ''
      errMsg.value = ''

      // Save content to localStorage before creating offer (per doc type)
      localStorage.setItem(contentKey(docType.value), offerInputText.value)

      // Validate form fields
      if (!offerInputText.value.trim()) {
        sellerAgentInformationErrMsg.value = 'Please fill in seller agent information'
        if (offerInputTextArea.value) {
          offerInputTextArea.value.style.borderColor = '#f7719a'
        }
        return
      } else {
        if (offerInputTextArea.value) {
          offerInputTextArea.value.style.borderColor = 'rgba(100, 145, 222, 0.2)'
        }
      }

      // Call backend API
      this.innerHTML = '<span class="btn-spinner"></span>Creating PDF...'
      this.disabled = true

      try {
        const response = await fetch(baseUrl + '/docs', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionStorage.getItem('token')}`
          },
          body: JSON.stringify({
            prompt: offerInputText.value.trim(),
            agent_name: userInfo.value.agent_name,
            doc_type: docType.value,
          }),
        })

        console.log({response});
        if (response.status === 401) {
          sessionStorage.removeItem('token');
          router.push('/login');
        }
        const result = await response.json()

        if (!result.success) {
           errMsg.value = result.detail || result.message || 'Failed to create PDF'
            this.innerHTML = 'Create Offer PDF'
            this.style.background = 'linear-gradient(135deg, #6491DE, #073D7F)'
            this.disabled = false
            return
        }

        // Use GCS URL directly from response
        pdfPerUrl.value = result.pdf_url

        this.innerHTML = 'PDF Created!'
        this.style.background = 'linear-gradient(135deg, #43e97b, #38f9d7)'

        // Store filename and doc ID for download and DocuSign
        window.currentPdfFilename = result.filename
        window.currentPdfUrl = result.pdf_url
        offerId.value = result.doc_id
        buyer1Email.value = result.buyer1_email
        buyer2Email.value = result.buyer2_email
        buyerAgentEmail.value = result.buyer_agent_email

        pdfReviewSection.style.display = 'block'
        pdfReviewSection.scrollIntoView({ behavior: 'smooth' })

        setTimeout(() => {
          this.innerHTML = 'Create Offer PDF'
          this.style.background = 'linear-gradient(135deg, #6491DE, #073D7F)'
          this.disabled = false
        }, 3000)
      } catch (error) {
        console.error('Error creating PDF:', error)
        alert(
          'Failed to create PDF. Please check if the backend server is running.'
        )

        this.innerHTML = 'Create Offer PDF'
        this.style.background = 'linear-gradient(135deg, #6491DE, #073D7F)'
        this.disabled = false
      }
    })
  }

  // Download PDF functionality
  if (downloadPdfBtn) {
    downloadPdfBtn.addEventListener('click', function () {
      if (!window.currentPdfUrl || !window.currentPdfFilename) {
        alert('No PDF file available for download')
        return
      }

      this.innerHTML = 'Downloading...'

      // Use GCS URL directly for download
      const link = document.createElement('a')
      link.href = window.currentPdfUrl
      link.download = window.currentPdfFilename
      link.target = '_blank'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      setTimeout(() => {
        this.innerHTML = 'Download PDF'
      }, 1000)
    })
  }

  // Submit to DocuSign functionality
  if (submitDocusignBtn) {
    submitDocusignBtn.addEventListener('click', async function () {
      // Validate DocuSign emails first
      if (!validateDocuSignEmails()) {
        return
      }

      // Check if PDF is available
      if (!window.currentPdfFilename || !offerId.value) {
        alert('No PDF file available for DocuSign submission. Please create an offer first.')
        return
      }

      this.innerHTML = 'Submitting to DocuSign...'
      this.disabled = true
      // Build signers for the roles this doc type actually needs.
      const roles = signerRolesForDocType.value
      let signers = [{email: buyer1Email.value.trim(), role: 'buyer1'}]
      if (roles.includes('buyer2') && buyer2Email.value.trim()) {
        signers.push({email: buyer2Email.value.trim(), role: 'buyer2'})
      }
      if (roles.includes('buyer_agent') && buyerAgentEmail.value.trim()) {
        signers.push({email: buyerAgentEmail.value.trim(), role: 'buyer_agent'})
      }
      try {
        const response = await fetch(baseUrl + `/docs/${offerId.value}/sign`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${sessionStorage.getItem('token')}`
          },
          body: JSON.stringify({
            signers: signers
          }),
        })

        if (response.status === 401) {
          sessionStorage.removeItem('token')
          router.push('/login')
          return
        }

        const result = await response.json()

        if (!result.success) {
          alert(result.detail || result.message || 'Failed to submit to DocuSign')
          this.innerHTML = 'Submit to DocuSign'
          this.style.background = 'linear-gradient(135deg, #6491DE, #073D7F)'
          this.disabled = false
          return
        }

        this.innerHTML = 'Submitted!'
        this.style.background = 'linear-gradient(135deg, #43e97b, #38f9d7)'
        alert('Document successfully submitted to DocuSign for signatures!')

        setTimeout(() => {
          this.innerHTML = 'Submit to DocuSign'
          this.style.background = 'linear-gradient(135deg, #6491DE, #073D7F)'
          this.disabled = false
        }, 3000)
      } catch (error) {
        console.error('Error submitting to DocuSign:', error)
        alert('Failed to submit to DocuSign. Please check if the backend server is running.')
        
        this.innerHTML = 'Submit to DocuSign'
        this.style.background = 'linear-gradient(135deg, #6491DE, #073D7F)'
        this.disabled = false
      }
    })
  }
})
// Create Offer Page Functionality
// document.addEventListener('DOMContentLoaded', function () {
// })
async function createOffer() {
  // Validate form fields
  const createPdfBtn = document.getElementById('create-pdf-btn')
  const sellerAgentInfo = document.getElementById('seller-agent-info')

  if (!sellerAgentInfo.value.trim()) {
    sellerAgentInfo.style.borderColor = '#f7719a'
  } else {
    sellerAgentInfo.style.borderColor = 'rgba(100, 145, 222, 0.2)'
  }

  // Call backend API
  createPdfBtn.innerHTML = 'Creating PDF...'
  createPdfBtn.disabled = true

  try {
    const response = await fetch(baseUrl + '/docs', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${sessionStorage.getItem('token')}`
      },
      body: JSON.stringify({
        prompt: sellerAgentInfo.value.trim(),
        agent_name: userInfo.value.agent_name,
      }),
    })

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const result = await response.json()

    createPdfBtn.innerHTML = 'PDF Created!'
    createPdfBtn.style.background = 'linear-gradient(135deg, #43e97b, #38f9d7)'

    // Update PDF preview with actual PDF embed using GCS URL
    const pdfPreview = document.getElementById('pdf-preview')
    offerId.value = result.doc_id
    buyer1Email.value = result.buyer1_email
    buyer2Email.value = result.buyer2_email
    buyerAgentEmail.value = result.buyer_agent_email
    const pdfUrl = result.pdf_url
    pdfPreview.innerHTML = `
                      <embed src="${pdfUrl}" type="application/pdf" width="100%" height="100%" style="border: none; border-radius: 8px;">
                      <div style="position: absolute; bottom: 10px; left: 10px; background: rgba(0,0,0,0.7); color: white; padding: 5px 10px; border-radius: 5px; font-size: 0.8rem;">
                          File: ${result.filename}
                      </div>
                  `
    pdfPreview.style.position = 'relative'

    // Store filename and URL for download
    window.currentPdfFilename = result.filename
    window.currentPdfUrl = result.pdf_url

    pdfReviewSection.style.display = 'block'
    pdfReviewSection.scrollIntoView({ behavior: 'smooth' })

    setTimeout(() => {
      this.innerHTML = 'Create Offer PDF'
      this.style.background = 'linear-gradient(135deg, #6491DE, #073D7F)'
      this.disabled = false
    }, 3000)
  } catch (error) {
    console.error('Error creating PDF:', error)
    alert(
      'Failed to create PDF. Please check if the backend server is running.'
    )

    this.innerHTML = 'Create Offer PDF'
    this.style.background = 'linear-gradient(135deg, #6491DE, #073D7F)'
    this.disabled = false
  }
}
</script>


<style scoped>
@import url('./home');
</style>